'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fixViewport = exports.isWixMobile = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _QueryUtils = require('./QueryUtils.js');

var _QueryUtils2 = _interopRequireDefault(_QueryUtils);

var _Utils = require('./Utils.js');

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isWixMobile = exports.isWixMobile = function isWixMobile() {
    var deviceType = _QueryUtils2.default.buildQueryHash().deviceType;
    if (deviceType && deviceType !== '') {
        return String(deviceType).indexOf('mobile') >= 0;
    } else {
        return undefined;
    }
};

var isMobile = _lodash2.default.memoize(function () {
    var wixMobile = isWixMobile();
    return _lodash2.default.isUndefined(wixMobile) ? _Utils2.default.isMobileWeb() : wixMobile;
});

function isLandscape() {
    var isLandscape = false;

    if (!isMobile()) {
        isLandscape = false;
    }

    if (!_lodash2.default.isUndefined(window.orientation)) {
        isLandscape = window.orientation === 90 || window.orientation === -90;
    } else {
        var mql = window.matchMedia('(orientation: landscape)');
        if (mql && mql.matches === true) {
            isLandscape = true;
        } else {
            isLandscape = false;
        }
    }
    return isLandscape;
}

function getScreenWidth() {
    if (isLandscape()) {
        return Math.max(window.screen.width, window.screen.height);
    } else {
        return window.screen.width;
    }
}

var fixViewport = exports.fixViewport = function fixViewport() {
    // TODO implement these 3 methods
    //
    // if (isSite() && isUserAgentMobile() && isInWix()) {
    // }
    //
    var viewportAspectRatio = 320 / getScreenWidth();
    document.body.style.transform = 'scale(' + viewportAspectRatio + ')';
    document.body.style.transformOrigin = '0 0';
    document.body.style.width = 100 / viewportAspectRatio + '%';
    document.body.style.height = 100 / viewportAspectRatio + '%';
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/ViewportUtils.js
// module id = 1007
// module chunks = 0